import React from 'react';

/** Style commun Entrea : listes, tableaux, filtres de grille alignés sur la colonne « sélection ». */
const BASE_CLASS =
  'rounded border-gray-300 text-entrea-royal focus:ring-entrea-royal/40 focus:ring-offset-0 disabled:opacity-50 disabled:cursor-not-allowed';

const SIZE_CLASS = {
  /** Cellule tableau / filtre compact */
  sm: 'h-4 w-4',
  /** Défaut : ligne tableau desktop */
  md: 'h-4 w-4',
  /** Carte mobile ou liste à forte cible tactile */
  lg: 'h-5 w-5 mt-0.5 flex-shrink-0',
};

/**
 * Case à cocher pour sélection de lignes dans les tableaux et listes Entrea
 * (en-tête « tout sélectionner », lignes, listes de membres dans un modal, etc.).
 */
export function TableListCheckbox({
  checked,
  onChange,
  disabled,
  className = '',
  size = 'md',
  'aria-label': ariaLabel,
  onClick,
  ...rest
}) {
  const sizeCls = SIZE_CLASS[size] || SIZE_CLASS.md;
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className={`${BASE_CLASS} ${sizeCls} ${className}`.trim()}
      aria-label={ariaLabel}
      onClick={onClick}
      {...rest}
    />
  );
}

export default TableListCheckbox;
